import { useEffect } from 'react'

import { saveExperienceRecentSearch } from './useExperienceRecentSearches'

function getExperienceRecentSearchItem(params: {
  destinationId?: string
  destinationName?: string
  experienceId?: string
  experienceName?: string
}): App.SearchItem | undefined {
  const {
    destinationId,
    destinationName,
    experienceId,
    experienceName,
  } = params

  if (destinationId && destinationName) {
    return {
      searchType: 'destination',
      value: destinationId.split(',')[0],
      format: {
        mainText: destinationName,
      },
    }
  }

  if (experienceId && experienceName) {
    return {
      searchType: 'experience',
      value: experienceId,
      format: {
        mainText: experienceName,
      },
    }
  }

  return undefined
}

function useAddExperienceRecentSearch(queryParams: URLSearchParams) {
  const destinationId = queryParams.get('destinationId') ?? undefined
  const destinationName = queryParams.get('destinationName') ?? undefined
  const experienceId = queryParams.get('experienceId') ?? undefined
  const experienceName = queryParams.get('experienceName') ?? undefined
  const checkIn = queryParams.get('checkIn') ?? undefined
  const checkOut = queryParams.get('checkOut') ?? undefined

  useEffect(() => {
    const recentSearchItem = getExperienceRecentSearchItem({
      destinationId,
      destinationName,
      experienceId,
      experienceName,
    })
    if (!recentSearchItem) return

    const dates = {
      checkIn,
      checkOut,
      isAnytime: !(checkIn || checkOut),
    }

    saveExperienceRecentSearch(recentSearchItem, dates, [])
  }, [destinationId, destinationName, experienceId, experienceName, checkIn, checkOut])
}

export default useAddExperienceRecentSearch
